import { render, staticRenderFns } from "./StockPositionKindTable.vue?vue&type=template&id=0427ecd8&"
import script from "./StockPositionKindTable.vue?vue&type=script&lang=js&"
export * from "./StockPositionKindTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports